import { match } from 'ts-pattern';
import { useWidgetRef } from '~/hooks/widgetHooks';

export const useClaimSource = () => {
  const widgetRef = useWidgetRef();
  return match(widgetRef)
    .with(null, () => 'Merchant_App' as const)
    .with('corso-concierge', () => 'Merchant_App' as const) // TODO add specific value and evaluate return type to match a shared type
    .with('kustomer', () => 'Kustomer_App_Integration' as const)
    .with('zendesk', () => 'Zendesk_App_Integration' as const)
    .exhaustive();
};
